/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Service information
 */
export type ServiceInfo = {
  /**
   * Service name
   */
  name: string;
  /**
   * Service version
   */
  version?: string | undefined;
};

/** @internal */
export const ServiceInfo$inboundSchema: z.ZodMiniType<ServiceInfo, unknown> = z
  .object({
    name: z.string(),
    version: z.optional(z.string()),
  });

export function serviceInfoFromJSON(
  jsonString: string,
): SafeParseResult<ServiceInfo, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ServiceInfo$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ServiceInfo' from JSON`,
  );
}
